import { RouterRootState } from "connected-react-router";
import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import MenuLayout from "../../components/menu-layout/menu-layout";
import SideMenu from "../../components/side-menu/side-menu";
import { SideMenuItems } from "../../models/SideMenuItems";
import { setMenuCompactState } from "../../store/menu/actions";
import ConfigurationIndex from "./configurations/index";
import EnrolmentIndex from "./enrolments/index";
import HardwareIndex from "./hardware/index";
import ModulesIndex from "./modules/index";
import MonitoringIndex from "./monitoring/index";
import NotificationIndex from "./notifications/index";
import ReportsIndex from "./reports/index";
import UserIndex from "./users/index";

function getPageForRoute(key: string) {
    const selected = {
        monitoring: <MonitoringIndex />,
        enrolment: <EnrolmentIndex />,
        notifications: <NotificationIndex />,
        reports: <ReportsIndex />,
        hardware: <HardwareIndex />,
        operators: <UserIndex />,
        configuration: <ConfigurationIndex />,
        modules: <ModulesIndex />,
    }[key];

    if (selected) {
        return selected;
    }
    return (
        <>
            <EnrolmentIndex />
        </>
    );
}

function getKeyFromPath(path: string, index = 2, getLast = false) {
    if (getLast) {
        return path.split("/").pop() ?? "";
    }
    return path.split("/")[index];
}


const EnrolmentsIndexPage: FC = () => {
    const dispatch = useDispatch();
    const page = useSelector((state: RouterRootState) => state.router.location.pathname);
    const compact = useSelector((state: any) => state.menu.compact);
    const history = useHistory();
    const [currentPage, setCurrentPage] = useState(getKeyFromPath(page, 1, true));

    return (
        <MenuLayout
            left={
                <SideMenu
                    menuItems={SideMenuItems}
                    isCompact={compact}
                    setIsCompact={(c) => {
                        dispatch(setMenuCompactState(c));
                    }}
                    onMenuSelect={(itemSelected) => {
                        setCurrentPage(getKeyFromPath(itemSelected, 1, true));
                        history.push("/access-control" + itemSelected);
                    }}
                    currentPage={currentPage}/>
            }
            right={getPageForRoute(getKeyFromPath(page))} />
    );
};

export default EnrolmentsIndexPage;
